"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanAndPlayDeltaAction = void 0;
var ScanAndPlayDeltaAction;
(function (ScanAndPlayDeltaAction) {
    ScanAndPlayDeltaAction["New"] = "NEW";
    ScanAndPlayDeltaAction["Updated"] = "UPDATED";
    ScanAndPlayDeltaAction["Deleted"] = "DELETED";
})(ScanAndPlayDeltaAction = exports.ScanAndPlayDeltaAction || (exports.ScanAndPlayDeltaAction = {}));
//# sourceMappingURL=scan-and-play-delta-action.js.map